import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { ClusterContactDto } from 'src/api/v2';
import { formatDateToNOString } from 'src/utils/FormatValue';
import ContactsTimerate from '../components/contacts/contacts-timerate/ContactsTimerate';
import { formatOrganizationNumber } from 'src/utils/format';
import { useTranslation } from 'react-i18next';

const columnHelper = createColumnHelper<ClusterContactDto>();

export function useClusterContactColumns() {
  const { t: tCommon } = useTranslation();

  return [
    columnHelper.accessor((row) => `${row.firstName} ${row.lastName}`, {
      id: 'name',
      cell: ({ row }) => (
        <Link
          to={`/resource-base/contacts/${row.original.id}`}
        >{`${row.original.firstName} ${row.original.lastName}`}</Link>
      ),
      meta: {
        alwaysVisible: true,
      },
    }),
    columnHelper.accessor((row) => row.mobilePhone, {
      id: 'phone',
      cell: ({ row }) => {
        if (!row.original.mobilePhone) {
          return null;
        }

        return <a href={`tel:${row.original.mobilePhone}`}>{row.original.mobilePhone}</a>;
      },
    }),
    columnHelper.accessor((row) => row.emailAddress, {
      id: 'email',
      cell: ({ row }) => {
        if (!row.original.emailAddress) {
          return null;
        }

        return <a href={`mailto:${row.original.emailAddress}`}>{row.original.emailAddress}</a>;
      },
    }),
    columnHelper.accessor((row) => row.clusterMember?.name || '', {
      id: 'member',
      cell: (info) =>
        info.row.original === undefined ? (
          <></>
        ) : (
          <Link to={`/resource-base/members/${info.row.original.clusterMemberId}`}>
            {info.row.original.clusterMember?.name}
          </Link>
        ),
      meta: {
        hide: true,
      },
    }),
    columnHelper.accessor((row) => row.clusterMember?.organizationNumber, {
      id: 'organizationNumber',
      cell: (info) => <span>{formatOrganizationNumber(info.getValue())}</span>,
      meta: {
        hide: true,
      },
    }),
    columnHelper.accessor((row) => row.timeRate?.hourRate ?? '', {
      id: 'hourRate',
      cell: ({ row }) => <ContactsTimerate timerate={row.original.timeRate} />,
      meta: {
        hide: true,
      },
    }),
    columnHelper.accessor((row) => (row.deactivatedDate ? formatDateToNOString(row.deactivatedDate) : ''), {
      id: 'retiredDate',
      cell: (info) => <span>{info.getValue()}</span>,
      meta: {
        hide: true,
      },
    }),
    columnHelper.accessor((row) => tCommon((row.gender as string).toLowerCase() as any), {
      id: 'gender',
      cell: (info) => <span>{info.getValue()}</span>,
      meta: {
        hide: true,
      },
    }),
    columnHelper.accessor((row) => row.interestAreas.map((area) => area.name).join(', '), {
      id: 'interestAreas',
      cell: (info) => <span>{info.getValue()}</span>,
      meta: {
        hide: true,
      },
    }),
  ];
}
